module.exports = __webpack_public_path__ + "img/vnm.6b3aef51.svg";